import React from "react";
import { Box, Button, MenuItem, Select } from "@mui/material";
import { AddRounded } from "@mui/icons-material";
import { AdminFilterBar, AdminPageHeader, DataTable, EmptyState, countLabel } from "../../../components/ui";
import PlanModel from "../../../models/plan.model";
import { daysOptions } from "./plans-options";
import { useManagePlans } from "./use-manage-plans";
import { buildPlanColumns } from "./plans-columns";
import PlanFormModal from "./components/PlanFormModal";

export const ManagePlans: React.FC = () => {
    const {
        loading,
        plans,
        modal,
        page,
        setPage,
        search,
        periodFilter,
        pageSize,
        filteredPlans,
        pagedRows,
        handleToggle,
        handleSave,
        openCreate,
        openEdit,
        closeModal,
        onSearch,
        onPeriodChange,
    } = useManagePlans();

    const columns = buildPlanColumns({ onEdit: openEdit, onToggle: handleToggle });

    return (
        <Box sx={{ width: "100%", p: { xs: "18px 16px 24px", md: 4 } }}>
            {modal.open && <PlanFormModal plan={modal.plan} onClose={closeModal} onConfirm={handleSave} />}

            <AdminPageHeader
                title="Planos"
                subtitle="Gestão de planos"
                action={
                    <Button
                        variant="contained"
                        startIcon={<AddRounded />}
                        onClick={openCreate}
                        sx={{ height: 44, borderRadius: "11px", textTransform: "none", fontWeight: 600 }}
                    >
                        Novo plano
                    </Button>
                }
            />

            <AdminFilterBar
                search={search}
                onSearch={onSearch}
                placeholder="Buscar por nome..."
                filters={
                    <Select
                        size="small"
                        value={periodFilter}
                        onChange={(e) => onPeriodChange(e.target.value)}
                        sx={{ height: 44, minWidth: 160, borderRadius: "10px" }}
                    >
                        <MenuItem value="all">Todos os períodos</MenuItem>
                        {daysOptions.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value}>
                                {opt.label}
                            </MenuItem>
                        ))}
                    </Select>
                }
                count={countLabel(filteredPlans.length, plans.length)}
            />

            <DataTable<PlanModel>
                columns={columns}
                rows={pagedRows}
                rowKey={(row) => String(row.id ?? row.name)}
                loading={loading}
                page={page}
                pageSize={pageSize}
                totalRows={filteredPlans.length}
                onPageChange={setPage}
                countLabel={countLabel(filteredPlans.length, plans.length)}
                emptyState={
                    <EmptyState
                        title="Nenhum plano encontrado"
                        description="Crie um novo plano para começar."
                        actionLabel="Novo plano"
                        onAction={openCreate}
                    />
                }
                minWidth={640}
            />
        </Box>
    );
};
